<div class="toolbar" [class.toolbar--no-fab]="!fab">
  @if (fab) {
  <!-- Grupo izquierdo -->
  <div class="tab-group left">
    @for (item of leftItems; track item.id) {
    <ng-container
      *ngTemplateOutlet="itemBtn; context: { $implicit: item }"
    ></ng-container>
    }
  </div>
  <!-- Columna del FAB -->
  <div class="center-spacer"></div>
  <!-- Grupo derecho -->
  <div class="tab-group right">
    @for (item of rightItems; track item.id) {
    <ng-container
      *ngTemplateOutlet="itemBtn; context: { $implicit: item }"
    ></ng-container>
    }
  </div>
  <!-- FAB central -->
  <div class="fab-wrap">
    <button
      class="fab"
      type="button"
      (click)="onFabClick()"
      [class.open]="fabOpen || isFabActive"
      [attr.aria-pressed]="fabOpen || isFabActive"
      [attr.aria-label]="(fab.labelKey || 'dashboard-toolbar.fab-default-label') | translate"
    >
      <ion-icon
        [name]="fab.iconSrc ? undefined : fab.icon"
        [src]="fab.iconSrc"
        class="fab-icon icon-ticket"
        aria-hidden="true"
      ></ion-icon>
      @if (fab.activeUrl) {
      <ion-icon name="close" class="fab-icon icon-close"></ion-icon>
      }
    </button>
  </div>
  } @else {
  <div class="tab-group flat">
    @for (item of items; track item.id) {
    <ng-container
      *ngTemplateOutlet="itemBtn; context: { $implicit: item }"
    ></ng-container>
    }
  </div>
  }

  <!-- Sin FAB: fila simple de ítems centrados -->
</div>

<div class="safe-bottom"></div>

<!-- Botón de ítem reutilizable -->
<ng-template #itemBtn let-item>
  <button
    class="tab"
    [class.active]="activeId === item.id"
    (click)="onItemClick(item)"
    [attr.aria-pressed]="activeId === item.id"
  >
    @if (item.icon) {
    <ion-icon
      [name]="item.icon"
      class="tab-icon"
      [ngClass]="item.iconClass"
    ></ion-icon>
    } @if (item.iconSrc && activeId !== item.id) {
    <ion-icon [src]="item.iconSrc" class="tab-icon"></ion-icon>
    } @if (item.iconActiveSrc && activeId === item.id) {
    <ion-icon [src]="item.iconActiveSrc" class="tab-icon"></ion-icon>
    }
    <span class="tab-label">{{ item.labelKey | translate }}</span>
  </button>
</ng-template>
